import React from "react";
import { Link } from "react-router-dom";
import LegalLayout from "@/components/legal/LegalLayout";
import { SITE, LEGAL } from "@/lib/config";
import SEO from "@/components/seo/SEO";

export default function AvisoLegal() {
    return (
        <>
            <SEO
                title="Aviso Legal"
                description="Aviso legal de ASATTA · Asociación de Alojamientos Turísticos de Tarifa. Información del titular y condiciones de uso del sitio web."
                path="/aviso-legal"
            />
            <LegalLayout
            testId="aviso-legal-page"
            eyebrow="Información legal"
            title="Aviso Legal"
            updatedAt={LEGAL.updatedAt}
        >
            <p>
                En cumplimiento del deber de información recogido en el artículo 10 de la
                Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información
                y de Comercio Electrónico (LSSI-CE), se ponen a disposición del usuario
                los siguientes datos relativos al titular de este sitio web.
            </p>

            <h2>1. Identificación del titular</h2>
            <ul>
                <li><strong>Denominación:</strong> {SITE.fullName} (en adelante, «ASATTA»)</li>
                <li><strong>CIF:</strong> {LEGAL.cif}</li>
                <li><strong>Domicilio social:</strong> {SITE.address}</li>
                <li><strong>Correo electrónico:</strong> <a href={`mailto:${SITE.email}`}>{SITE.email}</a></li>
                <li><strong>Naturaleza jurídica:</strong> asociación sin ánimo de lucro constituida conforme a la Ley Orgánica 1/2002, de 22 de marzo, reguladora del Derecho de Asociación.</li>
            </ul>

            <h2>2. Objeto del sitio web</h2>
            <p>
                Este sitio web tiene por objeto informar sobre la actividad de ASATTA,
                dar visibilidad al sector del alojamiento turístico de Tarifa, facilitar
                el contacto con la asociación, publicar noticias del sector, gestionar
                las solicitudes de alta de nuevos asociados y ofrecer un directorio de
                los alojamientos adheridos a la asociación.
            </p>

            <h2>3. Condiciones de uso</h2>
            <p>
                El acceso a este sitio web y la utilización de sus contenidos y servicios
                atribuye la condición de usuario e implica la aceptación plena y sin
                reservas del presente aviso legal. El usuario se compromete a hacer un
                uso adecuado y lícito del sitio web y de sus contenidos, quedando
                expresamente prohibido:
            </p>
            <ul>
                <li>El uso con fines o efectos contrarios a la ley, al orden público o a la moral.</li>
                <li>Reproducir, copiar, distribuir, transformar o modificar los contenidos, salvo autorización expresa del titular o cuando esté legalmente permitido.</li>
                <li>Introducir, almacenar o difundir programas, datos, virus o cualquier elemento que pueda dañar los sistemas informáticos del titular, de sus proveedores o de terceros.</li>
                <li>Realizar cualquier actividad que pueda dañar, sobrecargar o deteriorar el sitio web o impedir su normal uso.</li>
            </ul>

            <h2>4. Propiedad intelectual e industrial</h2>
            <p>
                Todos los contenidos del sitio web, incluyendo textos, fotografías,
                gráficos, imágenes, iconos, tecnología, software, así como su diseño
                gráfico y códigos fuente, constituyen una obra cuya propiedad pertenece a
                ASATTA o a sus licenciantes, sin que puedan entenderse cedidos al usuario
                ninguno de los derechos de explotación reconocidos por la normativa
                vigente en materia de propiedad intelectual.
            </p>
            <p>
                Las marcas, nombres comerciales o signos distintivos son titularidad de
                ASATTA o de terceros, sin que pueda entenderse que el acceso al sitio web
                atribuye ningún derecho sobre los mismos.
            </p>

            <h2>5. Exclusión de responsabilidad</h2>
            <p>
                ASATTA no garantiza la disponibilidad continua e ininterrumpida del sitio
                web ni la exactitud, integridad, veracidad o actualización de los
                contenidos que en él se ponen a disposición, si bien realizará los
                esfuerzos razonables para que la información sea precisa y esté
                actualizada.
            </p>
            <p>
                ASATTA no será responsable de los daños y perjuicios de cualquier
                naturaleza que puedan derivarse del acceso al sitio web o de la
                utilización de sus contenidos, en especial de los que puedan producirse
                por fallos técnicos, interrupciones del servicio o presencia de virus u
                otros elementos lesivos.
            </p>

            <h2>6. Enlaces a terceros</h2>
            <p>
                Este sitio web puede contener enlaces a otros sitios de terceros. ASATTA
                no ejerce ningún control sobre dichos sitios ni sobre sus contenidos, y
                no se responsabiliza en ningún caso de los mismos, ni garantiza la
                disponibilidad técnica, calidad, fiabilidad, exactitud, veracidad,
                validez o constitucionalidad de cualquier material o información
                contenida en dichos hiperenlaces.
            </p>

            <h2>7. Protección de datos</h2>
            <p>
                El tratamiento de los datos personales que se recogen a través del sitio
                web se rige por lo establecido en la{" "}
                <Link to="/politica-de-privacidad" className="underline">
                    Política de Privacidad
                </Link>{" "}
                y en la{" "}
                <Link to="/politica-de-cookies" className="underline">
                    Política de Cookies
                </Link>
                .
            </p>

            <h2>8. Legislación y jurisdicción aplicable</h2>
            <p>
                Las presentes condiciones se rigen por la legislación española. Para la
                resolución de cualquier controversia derivada del acceso o uso de este
                sitio web, las partes se someten expresamente a los Juzgados y
                Tribunales de la ciudad de Cádiz, con renuncia expresa a cualquier otro
                fuero que pudiera corresponderles.
            </p>
        </LegalLayout>
        </>
    );
}
